import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { graphql, compose } from 'react-apollo';
import gql from 'graphql-tag';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Star, ChevronRight } from 'lucide-react';

import s from './FiveStarReviews.css';
import cs from '../../commonStyle.css';
import ReviewCard from './ReviewCard';
import Shimmer from '../../Skeleton/Shimmer';

// Locale
import messages from '../../../locale/messages';

// GraphQL Query
const GET_FIVE_STAR_REVIEWS = gql`
  query getFiveStarReviews($limit: Int) {
    getFiveStarReviews(limit: $limit) {
      status
      count
      results {
        id
        reviewContent
        rating
        createdAt
        authorData {
          firstName
          lastName
          picture
          profileId
        }
        listingData {
          id
          title
          city
          coverPhoto
          listPhotos {
            id
            name
          }
        }
      }
    }
  }
`;

class FiveStarReviews extends React.Component {
    static propTypes = {
        data: PropTypes.shape({
            loading: PropTypes.bool,
            getFiveStarReviews: PropTypes.object,
        }),
    };

    render() {
        const { data } = this.props;

        // Show skeleton while loading
        if (data?.loading) {
            return (
                <div className={s.sectionWrapper}>
                    <div className={s.container}>
                        <div className={s.skeletonHeader}>
                            <Shimmer />
                        </div>
                        <div className={s.skeletonGrid}>
                            {[1, 2, 3, 4].map((i) => (
                                <div key={i} className={s.skeletonCard}>
                                    <Shimmer />
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            );
        }

        const reviews = data?.getFiveStarReviews?.results || [];

        // Don't render section if no reviews
        if (reviews.length === 0) {
            return null;
        }

        return (
            <section className={s.sectionWrapper}>
                <div className={s.container}>
                    {/* Section Header */}
                    <div className={s.sectionHeader}>
                        <div className={s.titleWrapper}>
                            <Star className={s.titleIcon} size={28} />
                            <h2 className={s.sectionTitle}>
                                <FormattedMessage {...messages.whatOurGuestsSay} />
                            </h2>
                        </div>
                    </div>

                    {/* Reviews Grid */}
                    <div className={s.reviewsGrid}>
                        {reviews.slice(0, 5).map((review, index) => (
                            <ReviewCard key={review.id} review={review} index={index} />
                        ))}
                    </div>
                </div>
            </section>
        );
    }
}

export default compose(
    injectIntl,
    withStyles(s, cs),
    graphql(GET_FIVE_STAR_REVIEWS, {
        options: {
            variables: { limit: 12 },
            ssr: true,
            fetchPolicy: 'cache-and-network',
        },
    })
)(FiveStarReviews);
